import React from 'react';
import PropTypes from 'prop-types';

const GatsbyHnLogo = ({width = '620px', height = '256px', css = {}}) => (
  <svg
    role="img"
    css={{verticalAlign: 'middle'}}
    width={width}
    height={height}
    viewBox="0 0 700 256"
    id="gatsbyhnlogo"
    aria-labelledby="svgLogoTitle svgLogoDesc"
    aria-required="true"
  >
    <title id="svgLogoTitle">Gatsby Hacker News logo</title>
    <desc id="svgLogoDesc">Logo for Gatsby Hacker News app</desc>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="gatsbyhn" fill="#744C9E">
        <g fillRule="nonzero">
          <path d="M128,0 C57.3075981,0 0,57.307374 0,128 C0,198.69285 57.3078221,256 128,256 C198.69285,256 256,198.692626 256,128 C256,57.307374 198.69285,0 128,0 Z M27.503973,129.334313 L126.665463,228.496027 C72.2144512,227.786305 28.2134711,183.785325 27.503973,129.334313 Z M150.496265,225.983324 L30.0166761,105.503735 C40.2328216,60.8232766 80.2223482,27.4871709 128,27.4871709 C161.397489,27.4871709 190.984927,43.7800881 209.262736,68.8464075 L195.346089,81.125855 C180.519662,59.8637627 155.886614,45.9486835 128,45.9486835 C92.4948508,45.9486835 62.259523,68.5011796 50.8311596,100.061636 L155.938588,205.169064 C181.463942,195.925651 201.095107,174.378594 207.669894,147.692325 L164.102633,147.692325 L164.102633,128.000224 L210.051317,128.000224 L210.051317,127.999776 L228.512829,127.999776 L228.512829,128 C228.512829,175.777652 195.176947,215.767178 150.496265,225.983324 Z" />
        </g>
        <g transform="translate(286.000000, 0.000000)">
          <path d="M42,108 L21,108 L21,150 L42,150 L42,257 L0,257 L0,1 L42,1 L42,108 Z" />
          <path d="M134,142 L30,142 L30,112 L134,112 L134,0 L174,0 L174,256 L134,256 L134,142 Z" />
          <path d="M335,209 L295,126.781383 L295,1 L335,1 L335,209 Z" />
          <path d="M220.299177,0.0266749229 L220.340292,-1.42108547e-14 L220.352925,0.0266749229 L220.79881,0.0266749229 L220.79881,0.96817108 L330.831202,233.30403 L330.847635,233.30403 L330.847635,233.338728 L331,233.660451 L330.847635,233.759303 L330.847635,254.980245 L298.273183,254.980245 L298.273183,253.826135 L188.341483,21.7028894 L188.224359,21.7028894 L188.224359,21.4555783 L188,20.9818402 L188.224359,20.8362802 L188.224359,0.0266749229 L220.299177,0.0266749229 Z" />
        </g>
      </g>
    </g>
  </svg>
);

GatsbyHnLogo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  css: PropTypes.object,
};

export default GatsbyHnLogo;



// WEBPACK FOOTER //
// ./src/components/logo.js